export default "__VITE_ASSET__BsSwtrHC__"